import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import ContextWrapper from 'components/templates/Wrappers/Sidebars/ContextWrapper/ContextWrapper';

const StyledDealflowEntitiesViewsWrapper = styled(ContextWrapper)`
  ${ComponentStyles}
`;

StyledDealflowEntitiesViewsWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowEntitiesViewsWrapper;
